export const getMereKindName = (index: number) => `meres.${index}.mereKind`
export const getContentName = (index: number) => `meres.${index}.content`
